export enum THEMES {
  dark = 'dark',
  light = 'light',
}
